export default context => {
    $("#Checkbox__Agree_Terms", context).trigger("change")
}
